import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconTheme(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path fill="currentColor" d="M7 17a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z" />
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M5 3a2 2 0 0 0-2 2v12a4 4 0 0 0 4 4h11.998a2 2 0 0 0 2-2v-4a2 2 0 0 0-2-2h-2.393l2.121-2.121a2 2 0 0 0 0-2.829l-2.828-2.828a2 2 0 0 0-2.829 0L11 7.292V5a2 2 0 0 0-2-2H5Zm13.998 16h-8.393l4-4h4.393v4ZM11 10.12v5.657l6.312-6.313-2.828-2.828L11 10.12ZM5 5h4v12a2 2 0 1 1-4 0V5Z"
        clipRule="evenodd"
      />
    </BaseIcon>
  );
}
